import { render } from "./MerchantProfilesIndex.vue?vue&type=template&id=f86fd320"
import script from "./MerchantProfilesIndex.vue?vue&type=script&lang=js"
export * from "./MerchantProfilesIndex.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./MerchantProfilesIndex.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_04ae61d8%2Fpackages%2Fbo%2Fsrc%2Fviews%2Fmerchant_profiles%2FMerchantProfilesIndex.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__